module.exports = __webpack_public_path__ + "static/media/patientWaiting.b84564da.wav";